import "./ThankYou.scss";

export default function ThankYou({ sendNew }: any) {
  return (
    <div className="thank-you">
      <div className="thank-you__title">Thank you! 🤘</div>
      <div className="thank-you__message">
        Your message has been accepted. You will recieve answer really soon!
      </div>
      <div className="thank-you__send-another" onClick={() => sendNew()}>
        send-new-message
      </div>
    </div>
  );
}
